
import React from "react";
import { cn } from "@/lib/utils";

interface UnstuckLogoProps {
  className?: string;
  textSize?: "sm" | "md" | "lg";
  showTagline?: boolean;
}

const UnstuckLogo: React.FC<UnstuckLogoProps> = ({
  className,
  textSize = "md",
  showTagline = true,
}) => {
  const textSizeClasses = {
    sm: "text-lg md:text-xl",
    md: "text-xl md:text-2xl",
    lg: "text-2xl md:text-3xl",
  };

  return (
    <div className={cn("flex flex-col items-center", className)}>
      <div className="flex items-center">
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mr-2"
        >
          <circle cx="18" cy="18" r="16" fill="#6127A0" />
          <path
            d="M18 4C10.268 4 4 10.268 4 18C4 25.732 10.268 32 18 32C25.732 32 32 25.732 32 18C32 10.268 25.732 4 18 4ZM18 30C11.373 30 6 24.627 6 18C6 11.373 11.373 6 18 6C24.627 6 30 11.373 30 18C30 24.627 24.627 30 18 30Z"
            fill="#00FF99"
          />
          <path
            d="M18 12L12 22H24L18 12Z"
            fill="#FBF3F1"
          />
          <path
            d="M18 24L12 14H24L18 24Z"
            fill="#D896A4"
          />
        </svg>
        <span className={cn("font-bold tracking-tight", textSizeClasses[textSize])}>
          <span className="text-[#6127A0]">Un</span>
          <span className="text-[#2F6665]">stuck</span>
        </span>
      </div>
      {showTagline && (
        <p className="text-xs italic mt-1 text-[#003F6B] dark:text-[#D896A4]">
          Break walls, build journeys
        </p>
      )}
    </div>
  );
};

export default UnstuckLogo;
